export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-foreground-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-circle-fill text-lg text-white"></i>
              </div>
              <span className="text-lg font-bold text-white whitespace-nowrap" style={{ fontFamily: 'var(--font-heading)' }}>
                91在线视频
              </span>
            </div>
            <p className="text-sm leading-relaxed text-foreground-400">
              汇聚海量国产影视资源，涵盖国产电影、国产电视剧、国产综艺及纪录片，全站高清免费在线观看不缓冲。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4 whitespace-nowrap" style={{ fontFamily: 'var(--font-heading)' }}>快速导航</h4>
            <div className="flex flex-col gap-2">
              <a href="#carousel" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">热播专题</a>
              <a href="#ranking" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">热门榜单</a>
              <a href="#index" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">影视合集</a>
              <a href="#updates" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">最新动态</a>
              <a href="#faq" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">常见问题</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4 whitespace-nowrap" style={{ fontFamily: 'var(--font-heading)' }}>影视分类</h4>
            <div className="flex flex-col gap-2">
              <a href="#index" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">国产电影</a>
              <a href="#index" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">国产电视剧</a>
              <a href="#index" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">热门综艺</a>
              <a href="#index" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">纪录片频道</a>
              <a href="#index" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">动漫动画</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4 whitespace-nowrap" style={{ fontFamily: 'var(--font-heading)' }}>合作伙伴</h4>
            <p className="text-sm text-foreground-400 leading-relaxed">
              诚邀各大影视制作公司、内容平台与发行机构洽谈合作，共同为观众提供更丰富的国产影视资源。
            </p>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 91在线视频 - 国产电影电视剧全集免费高清不缓冲
          </p>
          <div className="flex items-center gap-6">
            <a href="#contact" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">联系我们</a>
            <a href="#faq" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">常见问题</a>
            <a href="#about" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">关于我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}